import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { OrderTypeEnums } from 'src/app/enum/order-enums';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { CostCenterPriceModel } from 'src/app/models/archive/cost-center-price.model';
import { OrderDetailModel } from 'src/app/models/preliminaries/order-detail.model';
import { OrderModel } from 'src/app/models/preliminaries/order.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleSelectionTableModel } from 'src/app/models/tables/archive/article-selection-table.model';
import { OrderDetailCaptureTableModel } from 'src/app/models/tables/preliminaries/order-detail-capture-table.model';
import { OrderDetailService } from 'src/app/services/preliminaries/order-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { RegisterCostCenterPriceComponent } from 'src/app/views/archive/cost-center-price/register-cost-center-price/register-cost-center-price.component';
import { OrderPriceComponent } from 'src/app/views/preliminaries/order-price/order-price/order-price.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-order-adjustment-detail',
  templateUrl: './order-adjustment-detail.component.html',
  styleUrls: ['./order-adjustment-detail.component.scss'],
  standalone: false
})
export class OrderAdjustmentDetailComponent implements OnInit {
  @ViewChild('articleForOrderSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('costCenterPriceRegisterModal') costCenterPriceRegisterComponent?: CustomModalComponent | null = null;
  @ViewChild('orderPriceModal') orderPriceModalComponent?: CustomModalComponent | null = null;

  @Input() orderAdjustmentModel: OrderModel = new OrderModel();
  @Input() disableAllDetail: boolean = false;
  @Input() disablePartial: boolean = false;

  ascendant: boolean = true;
  ascendantArticle: boolean = true;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  columnSortArticle: string | null = null;
  componentOrderPriceModal = OrderPriceComponent;
  componentRegisterModal = RegisterCostCenterPriceComponent;
  componentTableSelection = CustomTableSelectComponent;
  costCenterPriceContract: CostCenterPriceModel = new CostCenterPriceModel();
  dataArticle: PagedResponseModel<ArticleSelectionTableModel> = new PagedResponseModel<ArticleSelectionTableModel>();
  detailData: PagedResponseModel<OrderDetailCaptureTableModel> = new PagedResponseModel<OrderDetailCaptureTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  filtersArticle: ColumnResponseModel[] = [];
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
  });
  inputsForPriceOrderModals$ = new BehaviorSubject<any>({
    orderDetail: 0,
    costCenterId: 0,
    disable: false
  });
  inputsForRegisterModals$ = new BehaviorSubject<any>({
    blockForm: false,
    costCenterPriceModel: new CostCenterPriceModel(),
    openFrom: ''
  });
  isFormView: boolean = false;
  limit: number = 10;
  limitArticle: number = 10;
  openFromCostCenterPrice: string = '';
  orderAdjustmentDetail: OrderDetailModel = new OrderDetailModel();
  orderAdjustmentDetails: OrderDetailModel[] = [];
  output$ = new Subject<any>();
  page: number = 1;
  pageArticle: number = 1;
  subscription: Subscription;
  tableActions: TableAction[] = [];

  constructor(private orderDetailService: OrderDetailService,
    private toastHandlerService: ToastHandlerService) { }

  async ngOnInit() {
    await this.getColumnsForDetailCaptureAsync();
    this.tableActions = this.getDefaultActions();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange': {
          this.onPageChangeForArticle(payload);
          break;
        }
        case 'onFilterChange': {
          this.onFilterChangeForArticle(payload);
          break;
        }
        default: {
          console.warn('Tipo de evento desconocido:', type);
        }
      }
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    const orderAdjustmentModel = changes["orderAdjustmentModel"];
    this.tableActions = this.disableAllDetail ? [] : this.getDefaultActions();
    if (orderAdjustmentModel && !orderAdjustmentModel.firstChange) {
      this.clearSelectionTrigger++;
      await this.getOrderDetailsForCaptureTable();
    }
  }

  async deleteOrderDetail(selectedIds: number[]) {
    if (selectedIds.length > 0) {
      const selectedDetails = this.detailData.items.filter(x => selectedIds.includes(x.orderDetailId));
      const hasRemission = selectedDetails.some(x => x.quantityRemission > 0);
      if (hasRemission) {
        return this.toastHandlerService.showToast('error', 'No es posible eliminar. Uno o más artículos están asociados a remisiones.');
      }
      const invalidOrigin = selectedDetails.some(x => !x.isOrderAdjustment);
      if (invalidOrigin) {
        return this.toastHandlerService.showToast('error', 'No es posible eliminar. Uno o más artículos fueron creados por area comercial.');
      }
      const result = await Swal.fire({
        title: 'Atención',
        text: '¿Realmente desea eliminar los detalles seleccionados?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí',
        cancelButtonText: 'No'
      });
      if (result.isConfirmed) {
        try {
          await firstValueFrom(this.orderDetailService.deleteSomeDetails(selectedIds, true));
          this.toastHandlerService.showToast('success', 'Los detalles fueron eliminados exitosamente.');
          this.clearSelectionTrigger++;
          await this.getOrderDetailsForCaptureTable();
        } catch (error) {
          console.error('Error al eliminar el detalle del pedido.', error);
        }
      }
    }
  }

  async editOrderDetail(id: number) {
    this.orderAdjustmentDetail = await this.getOrderDetailById(id);
    this.isFormView = true;
  }

  async getArticlesForDetails() {
    try {
      this.dataArticle = await firstValueFrom(this.orderDetailService.getArticlesForDetails(this.pageArticle, this.limitArticle,
        this.columnSortArticle, this.ascendantArticle, this.filtersArticle, this.orderAdjustmentModel.orderId));
      this.updateInputsForArticle();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getColumnsForArticles() {
    try {
      if (this.headerArticle.length === 0) {
        const response = await firstValueFrom(this.orderDetailService.getColumnsForArticles(this.orderAdjustmentModel.orderId));
        this.headerArticle = response;
        this.updateInputsForArticle();
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  async getColumnsForDetailCaptureAsync() {
    try {
      if (this.detailHeader.length === 0) {
        const response = await firstValueFrom(this.orderDetailService.getColumnsForDetailCaptureAsync());
        this.detailHeader = response;
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  getCostCenterPriceOpen(costCenterPrice: CostCenterPriceModel) {
    this.openFromCostCenterPrice = 'createOrderDetail';
    this.costCenterPriceContract = costCenterPrice;
    this.openCostCenterPriceRegisterModal();
  }

  getDefaultActions(): TableAction[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      },
      {
        label: 'Editar Precios C.Costos',
        icon: 'pi pi-dollar',
        action: 'prices-cost-center',
      },
    ];
  }

  async getOrderDetailByKeys(articleId: number): Promise<OrderDetailModel> {
    try {
      const orderId = this.orderAdjustmentModel.orderId;
      return await firstValueFrom(this.orderDetailService.getOrderDetailByKeys(orderId, articleId));
    } catch (error) {
      console.error('Error al obtener el detalle del pedido.', error);
      return new OrderDetailModel();
    }
  }

  async getOrderDetailById(orderDetailId: number): Promise<OrderDetailModel> {
    try {
      return await firstValueFrom(this.orderDetailService.getOrderDetailById(orderDetailId));
    } catch (error) {
      console.error('Error al obtener el detalle por id.', error);
      return new OrderDetailModel();
    }
  }

  async getOrderDetailsForCaptureTable() {
    try {
      const response = await firstValueFrom(this.orderDetailService.getOrderDetailsForCaptureTable(this.page, this.limit, this.columnSort,
        this.ascendant, this.orderAdjustmentModel.orderId));
      this.detailData = response;
      this.isFormView = false;
    } catch (error) {
      console.error('Error al buscar los detalles del pedido.', error);
    }
  }

  async getCostCenterPriceRegister(costCenterPrice: CostCenterPriceModel) {
    if (costCenterPrice.costCenterPriceId > 0) {
      if (this.openFromCostCenterPrice === "createOrderDetail" || this.openFromCostCenterPrice === "editOrderDetail") {
        this.costCenterPriceContract = costCenterPrice;
        await this.getOrderDetailsForCaptureTable();
      }
    }
  }

  async handleCostCenterPriceModal(orderDetailId: number) {
    try {
      const orderDetail = await this.getOrderDetailById(orderDetailId);
      const invalidOrigin = !orderDetail.isOrderAdjustment;
      if (invalidOrigin) {
        return this.toastHandlerService.showToast('error', 'No es posible modificar. El artículo fue creado por area comercial.');
      }
      const isNotRentalOrder = (this.orderAdjustmentModel.orderTypeId !== OrderTypeEnums.rental);
      const isGenericArticle = orderDetail.article?.swGeneric;
      if (isGenericArticle || isNotRentalOrder) {
        return this.openOrderPriceModal(orderDetail);
      }
      if (orderDetail.costCenterPrice) {
        this.orderAdjustmentDetail = orderDetail;
        this.openCostCenterPriceModal(orderDetail.costCenterPrice);
      }
    } catch (error) {
      console.error('Error al preparar la información de precios (centro de costos o pedido).', error);
    }
  }

  async handleSelectedItem(selectedItem: any) {
    if (selectedItem.length == 1) {
      const [{ articleId, rentalUnitId }] = selectedItem;
      const response = await this.getOrderDetailByKeys(articleId);
      if (response.orderDetailId === 0) {
        response.rentalUnitId = rentalUnitId;
        this.orderAdjustmentDetail = response;
      } else {
        this.orderAdjustmentDetail = response;
      }
    } else {
      const newDetails = selectedItem.map((element: {
        orderId: number,
        articleId: number,
        rentalUnitId: number
      }) => {
        const newOrderDetail = new OrderDetailModel();
        newOrderDetail.isOrderAdjustment = true;
        newOrderDetail.articleId = element.articleId;
        newOrderDetail.rentalUnitId = element.rentalUnitId;
        newOrderDetail.orderId = this.orderAdjustmentModel.orderId;
        return newOrderDetail;
      });
      this.orderAdjustmentDetails = newDetails;
    }
  }

  async onAction(event: { action: string, item?: OrderDetailCaptureTableModel, selectedItems?: number[] }) {
    switch (event.action) {
      case 'edit': {
        await this.editOrderDetail(event.item!.id);
        break;
      }
      case 'prices-cost-center': {
        await this.handleCostCenterPriceModal(event.item!.id);
        break;
      }
      case 'bulk-delete': {
        if (event.selectedItems) {
          await this.deleteOrderDetail(event.selectedItems);
        }
        break;
      }
    }
  }

  async openArticleSelectionModal() {
    this.filtersArticle = [];
    this.updateInputsForArticle();
    await Promise.all([
      this.getColumnsForArticles(),
      this.getArticlesForDetails(),
    ]);
    this.articleSelectionModalComponent?.show();
  }

  async onFilterChangeForArticle(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputsForArticle();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getOrderDetailsForCaptureTable();
  }

  async onPageChangeForArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    await this.getArticlesForDetails();
  }

  openCostCenterPriceModal(data: any) {
    this.costCenterPriceContract = new CostCenterPriceModel();
    this.openFromCostCenterPrice = "editOrderDetail";
    this.costCenterPriceContract.articleId = data.articleId;
    this.costCenterPriceContract.costCenterId = data.costCenterId;
    this.costCenterPriceContract.conceptInvoicingId = data.conceptInvoicingId;
    this.openCostCenterPriceRegisterModal();
  }

  async openOrderPriceModal(orderDetail: OrderDetailModel) {
    if (!this.orderAdjustmentModel.orderId) {
      return this.toastHandlerService.showToast('warning', 'Debe seleccionar un pedido para continuar.');
    }
    this.inputsForPriceOrderModals$.next({
      orderDetail: orderDetail,
      costCenterId: this.orderAdjustmentModel.costCenterId,
      disable: this.disablePartial
    });
    this.orderPriceModalComponent?.show();
  }

  openCostCenterPriceRegisterModal() {
    this.inputsForRegisterModals$.next({
      blockForm: this.disablePartial,
      costCenterPriceModel: this.costCenterPriceContract,
      openFrom: this.openFromCostCenterPrice
    });
    this.costCenterPriceRegisterComponent?.show();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async reload(reload: any) {
    if (reload) {
      await this.getOrderDetailsForCaptureTable();
    }
  }

  updateInputsForArticle() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: true,
      filters: this.filtersArticle,
    });
  }
}
